// extracted by mini-css-extract-plugin
export default {"immersiveHeaderInstr":"ImmersiveHeaderInstr_immersiveHeaderInstr__xjl85"};